<template>
  <div class="d-flex flex-column align-items-center gap-lgp w-100">
    <DropdownSingleSelect
      :model-value="cancelReason.reasonChoicePrimary?.id"
      :dropdown-options="primaryReasons"
      class="w-100 left-aligned-dropdown"
      @update:modelValue="onPrimaryReasonChange"/>
    <DropdownSingleSelect
      v-if="cancelReason.reasonChoicePrimary?.id"
      :model-value="cancelReason.reasonChoiceSecondary?.id"
      :dropdown-options="secondaryReasons"
      class="w-100 left-aligned-dropdown"
      @update:modelValue="onSecondaryReasonChange"/>
  </div>
</template>

<script setup>
import DropdownSingleSelect from '@/components/global/sequin/DropdownSingleSelect.vue'
import { computed } from 'vue'
import { usePauseCancel } from '@/composables/pauseCancel.js'

const props = defineProps({
  cancelReason: {
    type: Object,
    required: true
  }
})

const { cancelReasons } = usePauseCancel()

const primaryReasons = computed(() => {
  return cancelReasons.value.map(r => {
    return { text: r.reason, value: r.id }
  })
})

const secondaryReasons = computed(() => {
  const primaryReasons = cancelReasons.value.filter(r => r.id === props.cancelReason.reasonChoicePrimary?.id)
  if (primaryReasons.length === 0) {
    return []
  }
  const pr = primaryReasons[0]
  if (!('secondaryReasons' in pr)) {
    return []
  }
  return pr.secondaryReasons.map(r => {
    return { text: r.reason, value: r.id }
  })
})

const emit = defineEmits(['update:primary', 'update:secondary'])

const onPrimaryReasonChange = (event) => {
  emit('update:primary', event)
  emit('update:secondary', null)
}

const onSecondaryReasonChange = (event) => {
  emit('update:secondary', event)
}


</script>

<style scoped>
.left-aligned-dropdown :deep(.dropdown-list-item) {
  text-align: left;
}
</style>
